import './forgot-password-view/forgot-password-view.component';
import './forgot-password-view/forgot-password-view.scss';

import './login-view/login-view.component';
import './login-view/login-view.scss';

import './reset-view/reset-view.component';
import './reset-view/reset-view.scss';

import './sign-up-view/sign-up-view.component';
import './sign-up-view/sign-up-view.scss';
